import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";
import BrandIcon from "components/BrandIcon";
import { CapitalizeFirstLetter } from "utilities/typeUtils";

interface Props extends PickerListProps<server.dto.ClientSmall> {
  preferredClients: server.dto.ClientSmall[]
}

const ClientList = (props: Props) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedClientInstruction>({
    page: 1,
    perPage: 20,
    keyword: "",
  });

  const map = (clients: server.dto.ClientSmall[], keyword: string) => {
    const preferredClients = props.preferredClients.filter(c => c.name.toLowerCase().includes(keyword.toLowerCase()));

    const preferredClientsSet = new Set(props.preferredClients.map(c => c.clientId));
    const allOtherClients = clients.filter(c => !preferredClientsSet.has(c.clientId));

    return [...preferredClients, ...allOtherClients];
  }

  return <PickerList
    instruction={instruction}
    onInstructionChange={i => setInstruction(i)}
    queryKey="listClient"
    api={window.CoreApi.Client.PaginatedSmall}
    onClick={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={client => client.clientId}
    map={map}
    renderListItem={ClientListItem}
  />
};

export const ClientListItem = client => {
  const mappedLabelAndColor = mapAccessToLabelAndColor(client.access);
  return <div className="flex gap">
    <div>
      <BrandIcon iconUrl={client.iconUrl} name={client.name} size={20} />
    </div>
    <div>
      <div>{client.name}</div>
      {client.access !== "activePaid" && <div style={{ color: mappedLabelAndColor.color }}>
        {mappedLabelAndColor.label}
      </div>}
    </div>
  </div>
}

const mapAccessToLabelAndColor = (clientAccess: server.dto.ClientAccesses) => {
  const upperCaseLabel = (clientAccess[0].toUpperCase() + clientAccess.slice(1)) as CapitalizeFirstLetter<server.dto.ClientAccesses>;
  return {
    label: RESX.ClientAccessLabels[upperCaseLabel],
    color: RESX.ClientAccessHexColors[upperCaseLabel]
  }
}

export default ClientList;